import { BaseMutations } from '@/store/base-mutations';
import { MarketingFund } from '../types';
import MarketingFundState, {
  default_event,
  default_current_event_type,
  default_aplication,
  default_application_filters,
  default_event_filters,
  default_size_audience_reached,
  default_files_from_server,
  default_report_form,
} from './state';

export default class MarketingFundMutations extends BaseMutations<MarketingFundState> {
  SET_APLICATIONS(aplications: MarketingFund.Aplication[]) {
    this.state.aplications = aplications;
  }

  SET_EVENTS(events: MarketingFund.Event[]) {
    this.state.events = events;
  }

  SET_CURRENT_EVENT(data: MarketingFund.Event) {
    this.state.current_event = {
      ...data,
      event_type: data.event_type.slug,
      event_type_name: data.event_type.name,
      size_audience_reached_name: data.size_audience_reached?.name,
      size_audience_reached: data.size_audience_reached?.slug || null,
    };

    this.state.new_event = {
      ...data,
      event_type: data.event_type.slug,
      size_audience_reached_name: data.size_audience_reached?.name,
      size_audience_reached: data.size_audience_reached?.slug || null,
    };

    this.state.event_files_from_server = {
      user_list_file: data.mf_event_participants_list,
      pre_programm_file: data.mf_event_pre_program,
      pre_expenses_file: data.mf_event_pre_expenses,
      event_layout_design_file: data.mf_event_layout_design,
    };

    if (data.event_type) {
      this.state.current_event_type = data.event_type;
    }

    if (data.size_audience_reached) {
      this.state.current_size_audience_reached = data.size_audience_reached;
      // eslint-disable-next-line operator-assignment
      this.state.size_key = this.state.size_key + 1;
    }
  }

  UPD_APLICATIONS_FILTER_KEY({ key, value }: { key: keyof MarketingFund.AplicationsFilters, value: unknown }) {
    this.state.aplication_filters[key] = value;
  }

  CLEAR_APPLICATION_FILTERS() {
    this.state.aplication_filters = { ...default_application_filters };
  }

  UPD_EVENTS_FILTER_KEY({ key, value }: { key: keyof MarketingFund.EventsFilters, value: unknown }) {
    this.state.events_filters[key] = value;
  }

  CLEAR_EVENT_FILTERS() {
    this.state.events_filters = { ...default_event_filters };
  }

  UPD_NEW_EVENT({ key, value }: { key: keyof MarketingFund.Event, value: unknown }) {
    this.state.new_event[key] = value;
  }

  UPD_SIZE_AUDIENCE_REACHED(value: MarketingFund.SizeAudience) {
    if (!value) {
      this.state.new_event.size_audience_reached = '';
      this.state.current_event.size_audience_reached = '';
      this.state.current_size_audience_reached = { ...default_size_audience_reached };
    } else {
      this.state.new_event.size_audience_reached = value.slug;
      this.state.current_event.size_audience_reached = value.slug;
      this.state.current_size_audience_reached = value;
    }
  }

  UPD_SIZE_AUDIENCE_REACHED_LIST(items: MarketingFund.SizeAudience[]) {
    this.state.size_audience_reached_list = items;
  }

  TOGGLE_LOADING_APLICATIONS(toggle: boolean) {
    this.state.aplications_loading = toggle;
  }

  TOGGLE_LOADING_EVENTS(toggle: boolean) {
    this.state.events_loading = toggle;
  }

  ADD_EVENT(data: any) {
    this.state.events.push(data.newEvent);
  }

  SET_APLICATION(data: MarketingFund.AplicationDetail) {
    this.state.aplication = data;
  }

  SET_EVENTS_BY_APLICATION(events: MarketingFund.Event[]) {
    this.state.events_for_aplication = events;
  }

  SET_DEFAULT_EVENTS_BY_APLICATION() {
    this.state.events_for_aplication = [];
    this.state.aplication = { ...default_aplication };
  }

  SET_EVENTS_HISTORY_BY_APLICATION(history: MarketingFund.History[]) {
    this.state.history_for_aplication = history;
  }

  SET_DEFAULT_EVENT() {
    this.state.new_event = { ...default_event };
    this.state.current_event = { ...default_event };
    this.state.current_event_type = { ...default_current_event_type };
    this.state.event_files_from_server = { ...default_files_from_server };
  }

  SET_DEFAULT_REPORT_FORM() {
    this.state.new_report_form = { ...default_report_form };
  }

  UPD_EVENT_TYPE(event_type: MarketingFund.Type) {
    if (!event_type) {
      this.state.new_event.event_type = '';
      this.state.current_event_type = { ...default_current_event_type };
    } else {
      this.state.new_event.event_type = event_type.slug;
      this.state.current_event_type = { ...event_type };
    }
  }

  UPD_APPLICATION_ID(value: number) {
    this.state.current_application_id = value;
  }

  UPD_EVENT_ID(value: number) {
    this.state.current_event_id = value;
  }

  SET_EVENT_TYPES_LIST(value: MarketingFund.Type[]) {
    this.state.event_types_list = value;
  }

  SET_USER_LIST_FILE(value: File | null) {
    this.state.user_list_file = value;
  }

  SET_PRE_PROGRAMM_FILE(value: File | null) {
    this.state.pre_programm_file = value;
  }

  SET_PRE_EXPENSES_FILE(value: File | null) {
    this.state.pre_expenses_file = value;
  }

  SET_LAYOUT_DESIGN_FILE(value: File | null) {
    this.state.event_layout_design_file = value;
  }

  SET_TEMPLATE_MODAL_VISIBLE(value: boolean) {
    this.state.template_modal_visible = value;
  }

  SET_SEND_EVENT_TO_ATOL_MODAL(value: boolean) {
    this.state.send_event_to_atol_modal = value;
  }

  SET_CREATE_APPLICATION_VISIBLE_MODEL(value: boolean) {
    this.state.application_created_visible_model = value;
  }

  SET_NOT_CREATED_VISIBLE_MODEL(value: boolean) {
    this.state.not_created_visible_model = value;
  }

  SET_ALREADY_CREATED_VISIBLE_MODEL(value: boolean) {
    this.state.already_created_visible_model = value;
  }

  SENT_TO_ATOL_AVAILABLE_VISIBLE_MODEL(value: boolean) {
    this.state.sent_to_atol_available_visible_model = value;
  }

  UPD_EVENT_CREATED(value: boolean) {
    this.state.event_created = value;
  }

  UPD_EVENT_CHANGED(value: boolean) {
    this.state.event_changed = value;
  }

  UPD_PARTICIPANTS_LIST_FILE_DELETE_CONFIRM(value: boolean) {
    this.state.user_list_file_deleted = value;
  }

  UPD_PRE_PROGRAM_FILE_DELETE_CONFIRM(value: boolean) {
    this.state.pre_program_file_deleted = value;
  }

  UPD_PRE_EXPENSES_FILE_DELETE_CONFIRM(value: boolean) {
    this.state.pre_expenses_file_deleted = value;
  }

  UPD_EVENT_LAYOUT_DESIGN_FILE_DELETE_CONFIRM(value: boolean) {
    this.state.event_layout_design_file_deleted = value;
  }

  /** мутации по отчетам мероприятий */

  UPD_NEW_REPORT_EVENT_FORM({ key, value }: { key: keyof MarketingFund.ReportForm, value: unknown }) {
    this.state.new_report_form[key] = value;
  }

  SET_MF_EVENT_FINAL_AGREEMENT_FILE(value: File) {
    this.state.mf_event_final_agreement_file = value;
  }

  SET_MF_EVENT_CONFIRMING_DOCUMENTS(value: File) {
    this.state.mf_event_confirming_documents.push(value);
  }

  SET_MF_EVENT_FINAL_BANNER_MOCKUP(value: File) {
    this.state.mf_event_final_banner_mockup = value;
  }

  SET_MF_EVENT_FINAL_PROGRAM(value: File) {
    this.state.mf_event_final_program.push(value);
  }

  SET_MF_EVENT_FINAL_PARTICIPANTS_LIST(value: File) {
    this.state.mf_event_final_participants_list = value;
  }

  SET_MF_EVENT_FINAL_EXPENSES(value: File) {
    this.state.mf_event_final_expenses.push(value);
  }

  SET_MF_EVENT_FINAL_DESIGN(value: File) {
    this.state.mf_event_final_design = value;
  }

  SET_EVENT_REPORTS(data: MarketingFund.EventReport) {
    // this.state.current_event_reports = { ...data };

    this.state.new_report_form = {
      final_url: data.final_url,
      final_list_advertised_products: data.final_list_advertised_products,
      title_promo: data.title_promo,
      text_promo: data.text_promo,
      tags_list: data.tags_list,
      final_location: data.final_location,
      final_name_event: data.final_name_event,
      final_description_event: data.final_description_event,
      send_to_atol: false,
    };
  }

  SET_EVENT_REPORTS_FILES(data: MarketingFund.EventReport) {
    this.state.current_report_files = {
      mf_event_final_agreement: data.mf_event_final_agreement,
      mf_event_confirming_documents: data.mf_event_confirming_documents,
      mf_event_final_program: data.mf_event_final_program,
      mf_event_final_expenses: data.mf_event_final_expenses,
      mf_event_final_design: data.mf_event_final_design,
      mf_event_final_banner_mockup: data.mf_event_final_banner_mockup,
      mf_event_final_participants_list: data.mf_event_final_participants_list,
    };
  }

  SET_MF_LIMIT(marketing_fund_limit: number) {
    this.state.marketing_fund_limit = marketing_fund_limit;
  }

  SET_CREATED_APPLICATION_MESSAGE(value: string) {
    this.state.created_application_message = value;
  }

  UPD_ALL_SELECTED_EVENTS(value: boolean) {
    this.state.events = this.state.events.map((event) => ({ ...event, selected: value }));
  }

  UPD_SELECTED_EVENTS({ item, value }: { item: MarketingFund.Event, value: boolean }) {
    if (!item) {
      return;
    }

    this.state.events = this.state.events.map((event) => (event.id === item.id ? { ...event, selected: value } : event));
  }
}
